
/* @ngInject */
class TopNavService {
    constructor($http, $q, HPConfig) {
        this.$http = $http;
        this.$q = $q;
        this.HPConfig = HPConfig;
    }

    login() {
        return this.$http({
            url: `${this.HPConfig.heroProApi}Login`,
            method: 'POST',
        });
    }

    getContactHours() {
        return this.$http({
            url: `${this.HPConfig.heroProApi}RA/OfficeHours`,
            method: 'GET',
        });
    }

    logout() {
        this.$q.defer();
        let p2;

        const p1 = this.$http({
            url: `${this.HPConfig.heroProApi}Login/Logout`,
            method: 'POST',
        });

        return this.$q.all([p1, p2]);
    }
}

export default['$http', '$q', 'HPConfig', TopNavService];




// WEBPACK FOOTER //
// ./src/app/common/topNav/topNavFactory.js